// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM8 6L8 16H13V18H6V6H8ZM20 13.5H19C17.9846 13.5 17.0109 13.9034 16.2929 14.6213L16 14.9142V18H14V11H16L16 12.3314C16.8987 11.7919 17.9343 11.5 19 11.5H20V13.5Z"}}]};

const LogoAdobeLightroomFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-adobe-lightroom-filled',
    ref,
    icon: element,
  },
));

LogoAdobeLightroomFilledIcon.displayName = 'LogoAdobeLightroomFilledIcon';

export default LogoAdobeLightroomFilledIcon;
